export default "__VITE_ASSET__037e6a57__"